export default __webpack_public_path__ + "static/media/profile.c9331142.jpg";